export type RateStatus =
  | 'pending'
  | 'triggered'
  | 'invoice_created'
  | 'invoiced'
  | 'paid'
  | 'cancelled';

export type TriggerEvent =
  | 'ved_indgaaelse'
  | 'opstartsmoede'
  | 'optagelsesdagen'
  | 'design_godkendt'
  | 'sidste_revision'
  | 'ved_revision'
  | 'levering'
  | 'faktureret'
  | 'custom';

export const RATE_STATUSES: RateStatus[] = [
  'pending',
  'triggered',
  'invoice_created',
  'invoiced',
  'paid',
  'cancelled',
];

export const TRIGGER_EVENTS: TriggerEvent[] = [
  'ved_indgaaelse',
  'opstartsmoede',
  'optagelsesdagen',
  'design_godkendt',
  'sidste_revision',
  'ved_revision',
  'levering',
  'faktureret',
  'custom',
];

export const STATUS_LABEL: Record<RateStatus, string> = {
  pending: 'Afventer',
  triggered: 'Udløst',
  invoice_created: 'Faktura oprettet',
  invoiced: 'Faktureret',
  paid: 'Betalt',
  cancelled: 'Annulleret',
};

export const TRIGGER_LABEL: Record<TriggerEvent, string> = {
  ved_indgaaelse: 'Ved indgåelse',
  opstartsmoede: 'Opstartsmøde',
  optagelsesdagen: 'Optagelsesdagen',
  design_godkendt: 'Design godkendt',
  sidste_revision: 'Sidste revision',
  ved_revision: 'Ved revision',
  levering: 'Levering',
  faktureret: 'Faktureret',
  custom: 'Custom',
};

export interface RateRow {
  id: string;
  project_id: string;
  project_title: string;
  project_type: string;
  client_id: string;
  client_name: string;
  clickup_folder_id: string | null;
  clickup_list_id: string | null;
  rate_number: number;
  amount: string;
  trigger_event: TriggerEvent;
  status: RateStatus;
  sold_at: string;
  triggered_at: string | null;
  invoiced_at: string | null;
  clickup_trigger_task_id: string | null;
  notes: string | null;
  email_custom_text: string | null;
}

export interface ProjectGroup {
  project_id: string;
  project_title: string;
  project_type: string;
  client_id: string;
  client_name: string;
  sold_at: string;
  rates: RateRow[];
}

export function groupByProject(rows: RateRow[]): ProjectGroup[] {
  const map = new Map<string, ProjectGroup>();
  for (const r of rows) {
    let g = map.get(r.project_id);
    if (!g) {
      g = {
        project_id: r.project_id,
        project_title: r.project_title,
        project_type: r.project_type,
        client_id: r.client_id,
        client_name: r.client_name,
        sold_at: r.sold_at,
        rates: [],
      };
      map.set(r.project_id, g);
    }
    g.rates.push(r);
  }
  const out = Array.from(map.values());
  for (const g of out) g.rates.sort((a, b) => a.rate_number - b.rate_number);
  out.sort(
    (a, b) =>
      a.client_name.localeCompare(b.client_name, 'da') ||
      new Date(b.sold_at).getTime() - new Date(a.sold_at).getTime(),
  );
  return out;
}
